"use strict";
exports.__esModule = true;
exports.isMobilePhone = exports.isUkMobilePhone = exports.isPhone = void 0;
var phonePattern = '^[0-9]*$';
var ukMobilePattern = '^(\\+44|0044|0)7[0-9]*$';
var internationalMobilePattern = '^\\+?[0-9]{7,}$';
var validPhoneExpression = new RegExp(phonePattern, 'g');
var validUkMobileExpression = new RegExp(ukMobilePattern, 'g');
var validInternationalMobileExpression = new RegExp(internationalMobilePattern, 'g');
function isPhone(value) {
    return value.match(validPhoneExpression) !== null;
}
exports.isPhone = isPhone;
function isUkMobilePhone(value) {
    return value.match(validUkMobileExpression) !== null;
}
exports.isUkMobilePhone = isUkMobilePhone;
function isMobilePhone(value) {
    return value.match(validInternationalMobileExpression) !== null;
}
exports.isMobilePhone = isMobilePhone;
//# sourceMappingURL=phone.js.map